export default {
  navbar: {
    home: 'Home',
    smartSearch: 'Smart Search',
    tagSearch: 'Tag Search',
    drawCar: 'Draw a Car',
    more: 'More',
    articles: 'Articles',
    inspiration: 'Inspiration',
    forum: 'Forum',
    upload: 'Upload',
    about: 'About',
    menu: 'Menu',
    login: 'Login',
    register: 'Register',
    searchPlaceholderMobile: 'Search brands or models',
    searchPlaceholderDesktop: 'Search for car brands or models',
    myPoints: 'My Points',
    profile: 'Profile',
    myFavorites: 'My Favorites',
    myUploads: 'My Uploads',
    tagManagement: 'Tag Management',
    galleryBrowser: 'Gallery Browser',
    logout: 'Logout'
  },
  home: {
    latestUpload: 'Latest Upload',
    viewDetails: 'View Details',
    noImage: 'No Image',
    loadingLatestModels: 'Loading latest models...',
    brandNav: 'Brand Navigation',
    allBrands: 'All Brands',
    domesticBrands: 'Domestic Brands',
    overseasBrands: 'Overseas Brands',
    all: 'All',
    any: 'Any',
    noBrandsFound: 'No brands found matching criteria',
    totalBrands: '{count} brands in total',
    conceptCars: 'Concept Cars',
    newestFirst: 'Newest First',
    oldestFirst: 'Oldest First',
    latestUploadSort: 'Latest Upload',
    loadingModels: 'Loading model data...',
    noModelsFound: 'No model data found',
    loadingMoreModels: 'Loading more models...',
    allModelsLoaded: 'All models loaded',
    modelName: 'Model Name',
    unknownBrand: 'Unknown Brand',
    latestUploadedModels: 'Latest Uploaded Models',
    discoverHighDef: 'Browse official HD images of the latest models from Chinese brands',
    professionalGallery: 'Professional Car Gallery',
    discoverTenThousand: 'Discover over 10,000 official high-definition car images',
    panoramicView: '360° Panoramic View',
    experienceDetails: 'Experience details of the interior and exterior of the vehicle',
    retry: 'Retry',
    loadingModelData: 'Loading model data...',
    brandDetails: 'Brand Details',
    carModelDetails: 'Model Details',
    thanksFeedback: 'Thanks for your feedback! We will seriously consider your suggestions.'
  },
  modelDetail: {
    selectType: 'Select Model Type',
    noImages: 'No matching images found',
    allImages: 'All Images',
    exterior: 'Exterior',
    interior: 'Interior',
    detail: 'Detail',
    specs: 'Specifications',
    description: 'Description',
    price: 'MSRP',
    param: 'Parameter',
    brand: 'Brand',
    year: 'Year',
    updateSuccess: 'Model type updated successfully',
    updateFailed: 'Failed to update model type',
    orderSaved: 'Image order saved',
    orderSaveFailed: 'Failed to save image order',
    orderSaveRetry: 'Failed to save image order, please try again',
    typeAlreadySet: 'Current model type is already {type}, no update needed',
    fetchFailed: 'Failed to fetch model data'
  },
  imageGallery: {
    totalImages: 'Total Images',
    filteredCount: 'Filtered',
    currentPageCount: 'Current Page',
    filterTitle: 'Filters',
    modelCategory: 'Model Category',
    allTypes: 'All Types',
    brand: 'Brand',
    allBrands: 'All Brands',
    modelType: 'Model Type',
    allModels: 'All Models',
    conceptCar: 'Concept Car',
    exteriorStyle: 'Exterior Style',
    allExteriorStyles: 'All Exterior Styles',
    interiorStyle: 'Interior Style',
    allInteriorStyles: 'All Interior Styles',
    tagSearch: 'Tag Search',
    tagSearchPlaceholder: 'Enter tag keywords',
    popularTags: 'Popular Tags',
    clearFilters: 'Clear Filters',
    applyFilters: 'Apply Filters',
    loadingImages: 'Loading images...',
    loadingSubtitle: 'Please wait while we prepare the content for you',
    noImages: 'No Images',
    noImagesDesc: 'No images found with current filters, please try adjusting them',
    unknownModel: 'Unknown Model',
    unknownType: 'Unknown Type',
    loadingMore: 'Loading more images...'
  },
  about: {
    subtitle1: 'CarDesignSpace is an inspiration library and creative community for car design enthusiasts worldwide.',
    subtitle2: 'We gather here because of our passion.',
    createTitle: 'CREATE · Discovery',
    createDesc: 'We continuously aggregate outstanding global car designs, from classic masterpieces to cutting-edge concepts, building an online museum for you to explore design evolution.',
    designTitle: 'DESIGN · Collection',
    designDesc: 'Reconstructing classification systems from a design perspective, we help you efficiently build your personal inspiration library through precise brand, model, decade, and style tags.',
    shareTitle: 'SHARE · Inspiration',
    shareDesc: 'This is a free co-creation community. We encourage sharing, dialogue, and collision, letting every inspiration light up more creative possibilities.',
    followTitle: 'For more exciting content, please follow us',
    followSubtitle: 'WeChat Official Account | WeChat Mini Program',
    wechatOfficial: 'WeChat Official Account',
    wechatMini: 'WeChat Mini Program',
    wechatOfficialDesc: 'Scan to follow for the latest news',
    wechatMiniDesc: 'Scan to use, browse anytime, anywhere',
    pageTitle: 'About Us'
  },
  profile: {
    editProfile: 'Edit Profile',
    posts: 'Posts',
    likes: 'Likes',
    points: 'Points',
    myPosts: 'My Posts',
    shareSomething: 'Share something...',
    allPosts: 'All Posts',
    popularPosts: 'Popular Posts',
    delete: 'Delete',
    likesReceived: 'likes',
    comments: 'comments',
    viewDetails: 'Click to view details',
    noPostsSelf: 'You haven\'t posted anything yet',
    noPostsUser: 'This user hasn\'t posted anything yet',
    firstPostPrompt: 'Share your first update!',
    publishFirstPost: 'Post your first update',
    loadMore: 'Load More',
    likeRecords: 'Likes Received',
    likedYourPost: 'liked your post',
    viewPostDetails: 'Click to view post details',
    noLikes: 'No likes received yet',
    noLikesPrompt: 'Post high-quality content to get more likes!',
    goToForum: 'Go to Forum',
    myFavorites: 'My Favorites',
    favoritePosts: 'Favorite Posts',
    favoritedAt: 'Favorited at',
    removeFavorite: 'Remove Favorite',
    noFavorites: 'No favorites yet',
    noFavoritesPrompt: 'Go to the forum to favorite posts you like!',
    browseForum: 'Browse Forum'
  },
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    tips: 'Tips',
    loading: 'Loading...',
    loginExpired: 'Login expired, please login again',
    operationFailed: 'Operation failed, please try again',
    welcomeBack: 'Welcome back, {name}!',
    logoutSuccess: 'Logged out successfully',
    logoutConfirm: 'Are you sure you want to logout?'
  }
}
